<button
  (click)="isOpenSorting=!isOpenSorting"
  class="popular-button"
  cdkOverlayOrigin
  #sortingTrigger="cdkOverlayOrigin"
  [class.open]="isOpenSorting"
>
  <svg [icon]="icons.Sort" class="svg18 mr4 dark-gray-color"/>
  <span class="caption-2"> {{ activeSortingName | translate }} </span>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  [cdkConnectedOverlayOrigin]="sortingTrigger"
  [cdkConnectedOverlayOpen]="isOpenSorting"
  (backdropClick)="isOpenSorting = !isOpenSorting"
>
  <ul class="sorting">
    <li class="mobile">
      <p class="h3">{{ 'OTHER.SORTING' | translate }}</p>
      <button class="btn-empty" (click)="isOpenSorting = !isOpenSorting"><svg class="svg18 dark-gray-color" [icon]="icons.Close"/></button>
    </li>
    <li *ngFor="let option of options" class="sort-item">
      <button
        class="btn-empty sort-btn body-2"
        [class.chosen]="option.isSelected"
        (click)="chooseOption(option)"
      >
        {{ option.title | translate }}
        <svg class="svg18 primary-color" [icon]="icons.Selected" *ngIf="option.isSelected"/>
      </button>
    </li>
  </ul>

  <div class="backdrop" *ngIf="isOpenSorting" (click)="isOpenSorting = !isOpenSorting"></div>
</ng-template>
